import { userCompanyId } from "../../../../../utility/helpers";

const APIs = {};

const ArrivedDepartStatusModel = {
    id: {
        value: "",
    },
    company_id: {
        value: "",
        selectedOption: { label: "Select an option" },
        type: "integer",
        required: userCompanyId() ? false : true,
        message: "Company is required",
    },
    trip_route_id: {
        value: "",
        selectedOption: { label: "Select an option" },
        type: "integer",
        required: true,
        message: "Route is required",
    },
    trip_id: {
        value: "",
        selectedOption: { label: "Select an option" },
        type: "integer",
        required: true,
        message: "Trip is required",
    },
};

const DefaultOptions = {
    companies: [],
    routes: [],
    trips: [],
};

const requiredFields = Object.keys(ArrivedDepartStatusModel).filter(
    (key) => ArrivedDepartStatusModel[key].required
);

const checkFormValidity = (state) => {
    state = structuredClone(state);
    let count = 0;
    requiredFields.forEach((field) => {
        if (state[field].value == "") state[field].hasError = true;
        else {
            state[field].hasError = false;
            count++;
        }
    });

    return { status: count === requiredFields.length, state };
};

const dropDownFields = {
    company_id: "companies",
    trip_route_id: "routes",
    trip_id: "trips",
};

const updateFormValues = (field, value, state) => {
    const fieldState = state[field];
    fieldState.hasError = false;
    if (dropDownFields[field]) {
        if (fieldState.type == "integer") {
            fieldState.value = Number(value.value);
            fieldState.selectedOption = value;
        } else {
            fieldState.value = value.value;
            fieldState.selectedOption = value;
        }
    } else {
        switch (fieldState.type) {
            case "integer":
                fieldState.value = Number(value);
                break;
            case "float":
                fieldState.value = parseFloat(value);
                break;
            case "boolean":
                fieldState.value = value == "true";
                break;
            case "array":
                fieldState.value = value;
                break;
            default:
                fieldState.value = value;
        }
    }
    if (value || value.value) {
        fieldState.hasError = false;
    } else {
        fieldState.hasError = true;
    }

    return {
        ...state,
        [field]: fieldState,
    };
};

const getFormValues = (formState) => {
    const values = {};
    for (const key in formState) {
        values[key] = formState[key].value;
    }

    return values;
};

const findOption = (id, options, oldOption) => {
    const option =
        options?.length && options.find((option) => option.value == id);
    return option || oldOption;
};

const setFormValues = (values, formOptions) => {
    const model = structuredClone(ArrivedDepartStatusModel);

    for (const key in model) {
        if (dropDownFields[key]) {
            model[key].value = values[key];
            model[key].selectedOption = findOption(
                values[key],
                formOptions[dropDownFields[key]],
                model[key].selectedOption
            );
        } else model[key].value = values[key];
    }

    return model;
};

export {
    APIs,
    ArrivedDepartStatusModel,
    DefaultOptions,
    checkFormValidity,
    updateFormValues,
    getFormValues,
    setFormValues,
};
